import { message } from "antd";
import { setToken } from "../api/config";
import { login } from "../api/user";
import * as Sentry from "@sentry/react";
import { userAtom } from "@/store/user";
import { useSetRecoilState } from "recoil";

const useLogin = (props: { form }) => {
  const { form } = props;
  const setUserState = useSetRecoilState(userAtom);

  const tologin = async () => {
    const values = form.getFieldsValue();
    const result = await login<UserInfo & { uid: string }>({
      mobile: values.phone,
      verify_code: values.code,
    });
    // 登陆失效
    if (result.code !== 0) {
      return {
        isSuccess: false,
        msg: result.msg,
      };
    }
    setToken(result.data.token);
    localStorage.setItem("uid", result.data.uid);
    const userInfo = { ...result.data, phone: values.phone };
    localStorage.setItem("user", JSON.stringify(userInfo));
    setUserState(() => ({ ...userInfo }));
    Sentry.setUser({ uid: localStorage.getItem("uid") });
    return {
      isSuccess: true,
    };
  };
  return { tologin };
};

export default useLogin;
